import React from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import { HeaderContext } from '@/components/ReolinkHeader/common';
import type * as I from '@/interface/product';
import { ReoIcon } from '@reolink-web/components.basic';
import CompProductList from './CompProductList';
import { getStorePath } from '@/utils/function/sitePath';

interface IProductDropdownProps {
    navProductList: I.INavProductCategoryItem[];
}

const CompProductsDropdown: React.FC<IProductDropdownProps> = (props) => {
    const navProductList = props.navProductList;
    const { setIsShowSearch, getTextByKey } = React.useContext(HeaderContext);
    const [selectedCategoryId, setSelectedCategoryId] = React.useState<number>();

    const [showProductCategoryKey, setShowProductCategoryKey] = React.useState<string>();

    // 控制m端产品列表的显示，单独控制便于懒加载
    const [isMProductShowKey, setIsMProductShowKey] = React.useState<string>();

    React.useEffect(() => {
        if (navProductList.length > 0) {
            setSelectedCategoryId(navProductList[0].id);
        }
    }, [navProductList]);

    return (
        <div className={ styles['products-dropdown-wrapper'] }>
            <div className={ styles['product-category-select-wrapper'] }>
                <ul className={ styles['product-category-select'] }>
                    <li className={ classNames(styles['search-product']) }>
                        <input
                            className={ styles['search-product-input'] }
                            placeholder={ getTextByKey('search-products') }
                            onClick={ () => {
                                setIsShowSearch?.(true);
                            } }
                        />
                    </li>
                    {props.navProductList.map((item) => {
                        return (
                            <li
                                key={ item.id }
                                className={ classNames(styles['product-category-item'], {
                                    [styles['product-category-item-active']]: selectedCategoryId === item.id,
                                    [styles['product-category-item-show-sub']]: showProductCategoryKey === item.slug,
                                }) }
                                onMouseEnter={ () => {
                                    setSelectedCategoryId(item.id);
                                } }
                                onAnimationEnd={ () => {
                                    if (!showProductCategoryKey) {
                                        setIsMProductShowKey('');
                                    }
                                } }
                            >
                                <span
                                    className={ styles['product-category-item-content'] }
                                    onClick={ () => {
                                        if (showProductCategoryKey === item.slug) {
                                            setShowProductCategoryKey(undefined);
                                        }
                                        else {
                                            setShowProductCategoryKey(item.slug);
                                            setIsMProductShowKey(item.slug);
                                        }
                                    } }
                                >
                                    <span className={ styles['product-category-item-text'] }>{item.title}</span>
                                    <ReoIcon
                                        className={ styles['product-category-item-icon'] }
                                        name={ 'icon-new-arrow-right' }
                                    />
                                    <ReoIcon
                                        className={ styles['product-category-item-icon-m'] }
                                        name={ 'icon-icon_arrow-down' }
                                    />
                                </span>

                                <CompProductList
                                    categoryData={ item }
                                    className={ styles['product-category-item-list'] }
                                    style={{
                                        display: isMProductShowKey === item.slug ? '' : 'none',
                                    }}
                                />
                            </li>
                        );
                    })}
                    <li className={ styles['all-product'] }>
                        <a
                            className={ styles['all-product-link'] }
                            href={ getStorePath() }>
                            <span className={ styles['all-product-link-content'] }>
                                <span className={ styles['all-product-link-inner'] }>
                                    <span className={ styles['all-product-link-text'] }>
                                        {getTextByKey('all-products')}
                                    </span>
                                    <ReoIcon
                                        className={ styles['all-product-link-icon'] }
                                        name={ 'icon-new-arrow-right' }
                                    />
                                </span>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
            {props.navProductList.map((item) => {
                return (
                    <CompProductList
                        key={ item.id }
                        className={ styles['current-product-list'] }
                        categoryData={ item }
                        style={{
                            display: selectedCategoryId === item.id ? '' : 'none',
                        }}
                    />
                );
            })}
        </div>
    );
};

export default CompProductsDropdown;
